import type {DependenciesManager, DalValue, DependenciesBuilder} from '@wix/document-services-types'
import type {ExternalsHandler} from '../../constants'
import type {DetailedValue, ExtendedRefInfo} from '@wix/import-export-utils'
import {stripHashIfExists} from '../../../../../utils/refArrayUtils'
import _ from 'lodash'
import {DATA_TYPES} from '../../../../../constants/constants'

const DATAQUERY_REGEX = /dataquery="(.*?)"/g

export const richTextRefsHandler: ExternalsHandler<string> = {
    pack: (ref: DetailedValue<string>, dependenciesBuilder: DependenciesBuilder) => {
        const refs = Array.from(ref.value.matchAll(DATAQUERY_REGEX)).map(([, id]) => stripHashIfExists(id))

        for (const refId of refs) {
            dependenciesBuilder.references.addNonOwnedRef(refId, DATA_TYPES.data)
        }
    },
    unpack: (
        ref: DetailedValue<string>,
        dependenciesManager: DependenciesManager,
        refFieldInfo: ExtendedRefInfo,
        item: DalValue
    ) => {
        const newText: string = ref.value.replace(DATAQUERY_REGEX, (match, oldId) => {
            const newId: string = dependenciesManager.references.getNewItemRef(oldId, refFieldInfo)
            return match.replace(oldId, newId)
        })

        _.set(item, ref.path, newText)
    }
}
